import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.join.js";
// 获取列表内容封装在mixins内部  getTableData方法 初始化已封装完成
var path = process.env.VUE_APP_BASE_API;
import { getUserList, setUserAuthority, register, deleteUser as _deleteUser } from "@/api/user";
import { getUserInfoMap } from "@/utils/dictionary";
import { getAuthorityList } from "@/api/authority";
import infoList from "@/mixins/infoList";
import { mapGetters } from "vuex";
// import CustomPic from "@/components/customPic";
import ChooseImg from "@/components/chooseImg";
export default {
  name: "Api",
  mixins: [infoList],
  components: {
    ChooseImg: ChooseImg
  },
  data: function data() {
    return {
      listApi: getUserList,
      path: path,
      authOptions: [],
      addUserDialog: false,
      updateUserDialog: false,
      userUpdateInfo: {},
      userInfoMap: {},
      searchInfo: {},
      userInfo: {
        username: "",
        password: "",
        nickName: "",
        headerImg: "",
        authorityId: "",
        phone: ""
      },
      statusOption: [{
        val: 1,
        label: "激活"
      }, {
        val: 0,
        label: "禁用"
      }],
      rules: {
        username: [{
          required: true,
          message: "请输入用户名",
          trigger: "blur"
        }, {
          min: 6,
          message: "最低6位字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入用户密码",
          trigger: "blur"
        }, {
          min: 6,
          message: "最低6位字符",
          trigger: "blur"
        }],
        nickName: [{
          required: true,
          message: "请输入用户昵称",
          trigger: "blur"
        }],
        authorityId: [{
          required: true,
          message: "请选择用户角色",
          trigger: "blur"
        }]
      },
      rulesUpdate: {
        password: [{
          message: "请输入用户密码",
          trigger: "blur"
        }, {
          min: 6,
          message: "最低6位字符",
          trigger: "blur"
        }],
        nickName: [{
          required: true,
          message: "请输入用户昵称",
          trigger: "blur"
        }],
        authorityId: [{
          required: true,
          message: "请选择用户角色",
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters("user", ["token"])),
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserInfoMap();
            case 2:
              _this.userInfoMap = _context.sent;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit() {
      this.getTableData();
    },
    openHeaderChange: function openHeaderChange() {
      this.$refs.chooseImg.open();
    },
    setOptions: function setOptions(authData) {
      this.authOptions = [];
      this.setAuthorityOptions(authData, this.authOptions);
    },
    setAuthorityOptions: function setAuthorityOptions(AuthorityData, optionsData) {
      var _this2 = this;
      AuthorityData && AuthorityData.map(function (item) {
        if (item.children && item.children.length) {
          var option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            disabled: true,
            children: []
          };
          if (item.IsPermission) {
            option.disabled = false;
          }
          _this2.setAuthorityOptions(item.children, option.children);
          optionsData.push(option);
        } else {
          var _option = {
            authorityId: item.authorityId,
            authorityName: item.authorityName,
            disabled: true
          };
          if (item.IsPermission) {
            _option.disabled = false;
          }
          optionsData.push(_option);
        }
      });
    },
    deleteUser: function deleteUser(row) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _deleteUser({
                id: row.ID
              });
            case 2:
              res = _context2.sent;
              if (res.code == 0) {
                _this3.getTableData();
                row.visible = false;
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    enterAddUserDialog: function enterAddUserDialog() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.$refs.userForm.validate( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!valid) {
                          _context3.next = 9;
                          break;
                        }
                        _context3.next = 3;
                        return register(_this4.userInfo);
                      case 3:
                        res = _context3.sent;
                        if (!(res.code == 0)) {
                          _context3.next = 9;
                          break;
                        }
                        _this4.$message({
                          type: "success",
                          message: "创建成功"
                        });
                        _context3.next = 8;
                        return _this4.getTableData();
                      case 8:
                        _this4.closeAddUserDialog();
                      case 9:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    enterUpdateUserDialog: function enterUpdateUserDialog() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this5.$refs.userUpdateForm.validate( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!valid) {
                          _context5.next = 9;
                          break;
                        }
                        _context5.next = 3;
                        return register(_this5.userUpdateInfo);
                      case 3:
                        res = _context5.sent;
                        if (!(res.code == 0)) {
                          _context5.next = 9;
                          break;
                        }
                        _this5.$message({
                          type: "success",
                          message: "修改成功"
                        });
                        _context5.next = 8;
                        return _this5.getTableData();
                      case 8:
                        _this5.closeUpdateUserDialog();
                      case 9:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    closeAddUserDialog: function closeAddUserDialog() {
      this.$refs.userForm.resetFields();
      this.addUserDialog = false;
    },
    closeUpdateUserDialog: function closeUpdateUserDialog() {
      this.$refs.userUpdateForm.resetFields();
      this.updateUserDialog = false;
    },
    handleAvatarSuccess: function handleAvatarSuccess(res) {
      this.userInfo.headerImg = res.data.file.url;
    },
    addUser: function addUser() {
      this.addUserDialog = true;
    },
    updateUser: function updateUser(data) {
      this.userUpdateInfo = data;
      this.$set(this.userUpdateInfo, "username", data.userName);
      this.updateUserDialog = true;
    },
    changeAuthority: function changeAuthority(row) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return setUserAuthority({
                uuid: row.uuid,
                authorityId: row.authority.authorityId
              });
            case 2:
              res = _context7.sent;
              if (res.code == 0) {
                _this6.$message({
                  type: "success",
                  message: "角色设置成功"
                });
              }
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    getCharacter: function getCharacter() {
      var result = [];
      for (var i = 0; i < 6; i++) {
        var randNum = Math.ceil(Math.random() * 25);
        result.push(String.fromCharCode(65 + randNum));
      }
      console.log(result.join(""));
      this.$set(this.userInfo, "password", result.join(""));
    },
    getCharacterUpdate: function getCharacterUpdate() {
      var result = [];
      for (var i = 0; i < 6; i++) {
        var randNum = Math.ceil(Math.random() * 25);
        result.push(String.fromCharCode(65 + randNum));
      }
      console.log(result.join(""));
      this.$set(this.userUpdateInfo, "password", result.join(""));
    }
  },
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var res;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            _this7.getTableData();
            _context8.next = 3;
            return getAuthorityList({
              page: 1,
              pageSize: 999
            });
          case 3:
            res = _context8.sent;
            _this7.setOptions(res.data.list);
          case 5:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }))();
  }
};